import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { HomeIcon, PlayIcon, CompassIcon } from './BespokeIcons';

/**
 * ElchmE Project Footer - Persistent navigation across all views
 * Ensures users can always get back to key destinations
 */
export const ElchmEProjectFooter = ({ currentView = 'board' }) => {
  const navigate = useNavigate();
  
  return (
    <footer className="fixed bottom-0 inset-x-0 h-16 backdrop-blur-md bg-black/90 border-t border-white/10 z-40">
      <div className="max-w-7xl mx-auto h-full px-4 flex items-center justify-between">
        {/* Left: Quick actions */}
        <div className="flex items-center gap-2">
          <Button 
            onClick={() => navigate('/')}
            variant="ghost"
            size="sm"
            className="text-white/50 hover:text-amber-400 hover:bg-amber-500/10"
            data-testid="footer-home-btn"
          >
            <HomeIcon size={16} color="currentColor" className="mr-2" />
            Home
          </Button>
          
          <Button 
            onClick={() => navigate('/elchme')}
            variant="ghost"
            size="sm"
            className="text-white/50 hover:text-emerald-400 hover:bg-emerald-500/10"
            data-testid="footer-new-elchme-btn"
          >
            <PlayIcon size={16} color="currentColor" className="mr-2" />
            New ElchmE
          </Button>
        </div>
        
        {/* Center: Current location indicator */}
        <div className="text-xs text-white/30 hidden sm:block">
          {currentView === 'board' && 'Project Hub'}
          {currentView === 'project-detail' && 'Project Details'}
          {currentView === 'vision-quest' && 'Vision Quest'}
        </div>
        
        {/* Right: Dashboard */}
        <a
          href="https://belongingsessions.com/dashboard"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2 text-sm text-amber-400/80 hover:text-amber-400 hover:bg-amber-500/10 rounded-lg transition-all"
          data-testid="footer-dashboard-btn"
        >
          <CompassIcon size={18} color="#F59E0B" />
          <span className="hidden sm:inline">Dashboard</span>
        </a>
      </div>
      
      {/* Padding for safe area on mobile */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </footer>
  );
};

export default ElchmEProjectFooter;
